import * as React from "react";

function SvgComponent(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="1em" height="1em" {...props}><g color="#000" fontWeight={400} fontFamily="sans-serif" fill="#2e3436"><path d="M12.987 2.033a3.515 3.515 0 013.005 3.711A3.514 3.514 0 0112.5 9a1 1 0 110-2c.798 0 1.44-.6 1.496-1.395a1.488 1.488 0 00-1.287-1.591 1.487 1.487 0 00-1.676 1.174 1 1 0 11-1.957-.417 3.513 3.513 0 013.91-2.738z" style={{
        lineHeight: "normal",
        fontVariantLigatures: "normal",
        fontVariantPosition: "normal",
        fontVariantCaps: "normal",
        fontVariantNumeric: "normal",
        fontVariantAlternates: "normal",
        fontFeatureSettings: "normal",
        textIndent: 0,
        textAlign: "start",
        textDecorationLine: "none",
        textDecorationStyle: "solid",
        textDecorationColor: "#000",
        textTransform: "none",
        textOrientation: "mixed",
        shapePadding: 0,
        isolation: "auto",
        mixBlendMode: "normal"
      }} overflow="visible" /><path d="M0 7v2h12.5V7z" style={{
        lineHeight: "normal",
        fontVariantLigatures: "normal",
        fontVariantPosition: "normal",
        fontVariantCaps: "normal",
        fontVariantNumeric: "normal",
        fontVariantAlternates: "normal",
        fontFeatureSettings: "normal",
        textIndent: 0,
        textAlign: "start",
        textDecorationLine: "none",
        textDecorationStyle: "solid",
        textDecorationColor: "#000",
        textTransform: "none",
        textOrientation: "mixed",
        shapePadding: 0,
        isolation: "auto",
        mixBlendMode: "normal"
      }} overflow="visible" fillRule="evenodd" /><path d="M9.397 15.936a2.99 2.99 0 001.95-.254 3.01 3.01 0 001.573-3.373A3.009 3.009 0 0010.002 10a1 1 0 100 2 .99.99 0 01.97.77.992.992 0 01-.523 1.125.986.986 0 01-1.21-.252 1 1 0 10-1.534 1.285c.445.53 1.047.874 1.692 1.008z" style={{
        lineHeight: "normal",
        fontVariantLigatures: "normal",
        fontVariantPosition: "normal",
        fontVariantCaps: "normal",
        fontVariantNumeric: "normal",
        fontVariantAlternates: "normal",
        fontFeatureSettings: "normal",
        textIndent: 0,
        textAlign: "start",
        textDecorationLine: "none",
        textDecorationStyle: "solid",
        textDecorationColor: "#000",
        textTransform: "none",
        textOrientation: "mixed",
        shapePadding: 0,
        isolation: "auto",
        mixBlendMode: "normal"
      }} overflow="visible" /><path d="M0 10v2h10v-2z" style={{
        lineHeight: "normal",
        fontVariantLigatures: "normal",
        fontVariantPosition: "normal",
        fontVariantCaps: "normal",
        fontVariantNumeric: "normal",
        fontVariantAlternates: "normal",
        fontFeatureSettings: "normal",
        textIndent: 0,
        textAlign: "start",
        textDecorationLine: "none",
        textDecorationStyle: "solid",
        textDecorationColor: "#000",
        textTransform: "none",
        textOrientation: "mixed",
        shapePadding: 0,
        isolation: "auto",
        mixBlendMode: "normal"
      }} overflow="visible" fillRule="evenodd" /><path d="M5.14 1.023c.533-.07 1.09.03 1.577.313a2.508 2.508 0 011.162 2.81A2.506 2.506 0 015.467 6a1 1 0 110-2 .487.487 0 00.479-.37.494.494 0 00-.231-.564.485.485 0 00-.598.079 1 1 0 11-1.416-1.413 2.49 2.49 0 011.44-.709z" style={{
        lineHeight: "normal",
        fontVariantLigatures: "normal",
        fontVariantPosition: "normal",
        fontVariantCaps: "normal",
        fontVariantNumeric: "normal",
        fontVariantAlternates: "normal",
        fontFeatureSettings: "normal",
        textIndent: 0,
        textAlign: "start",
        textDecorationLine: "none",
        textDecorationStyle: "solid",
        textDecorationColor: "#000",
        textTransform: "none",
        textOrientation: "mixed",
        shapePadding: 0,
        isolation: "auto",
        mixBlendMode: "normal"
      }} overflow="visible" /><path d="M0 4v2h5.467V4z" style={{
        lineHeight: "normal",
        fontVariantLigatures: "normal",
        fontVariantPosition: "normal",
        fontVariantCaps: "normal",
        fontVariantNumeric: "normal",
        fontVariantAlternates: "normal",
        fontFeatureSettings: "normal",
        textIndent: 0,
        textAlign: "start",
        textDecorationLine: "none",
        textDecorationStyle: "solid",
        textDecorationColor: "#000",
        textTransform: "none",
        textOrientation: "mixed",
        shapePadding: 0,
        isolation: "auto",
        mixBlendMode: "normal"
      }} overflow="visible" fillRule="evenodd" /></g></svg>;
}

export default SvgComponent;